import React from "react";

const CognitiveLogo: React.FC<{ size?: number; className?: string }> = ({
  size = 32,
  className = "",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        {/* Split background - blue left, yellow right */}
        <linearGradient id={`bgSplit-${size}`} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#1E40AF" />
          <stop offset="50%" stopColor="#1E40AF" />
          <stop offset="50%" stopColor="#FCD34D" />
          <stop offset="100%" stopColor="#FCD34D" />
        </linearGradient>
      </defs>
      
      {/* Split background */}
      <rect width="100" height="100" fill={`url(#bgSplit-${size})`} rx="8" />
      
      {/* Bear silhouette */}
      <path 
        d="M50 15 C45 15, 42 18, 42 22 C40 20, 37 20, 35 22 C33 24, 33 27, 35 29 C32 32, 30 36, 30 41 C30 45, 32 48, 35 50 C33 52, 32 55, 32 58 C32 65, 35 70, 40 73 C42 75, 45 76, 48 76 C50 78, 52 78, 54 76 C57 76, 60 75, 62 73 C67 70, 70 65, 70 58 C70 55, 69 52, 67 50 C70 48, 72 45, 72 41 C72 36, 70 32, 67 29 C69 27, 69 24, 67 22 C65 20, 62 20, 60 22 C58 18, 55 15, 50 15 Z M45 25 C46 25, 47 26, 47 27 C47 28, 46 29, 45 29 C44 29, 43 28, 43 27 C43 26, 44 25, 45 25 Z M55 25 C56 25, 57 26, 57 27 C57 28, 56 29, 55 29 C54 29, 53 28, 53 27 C53 26, 54 25, 55 25 Z M50 35 C51 35, 52 36, 52 37 C52 38, 51 39, 50 39 C49 39, 48 38, 48 37 C48 36, 49 35, 50 35 Z" 
        fill="black" 
      />
    </svg>
  );
};

export default CognitiveLogo;
